<template>
  <div class="mini-event row gx-0">
    <a
      v-if="event.post_thumbnail_url"
      class="img-wrapper col-md-4 order-md-last"
      :href="event.permalink"
      v-bind:style="{
        backgroundImage: 'url(' + event.post_thumbnail_url + ')',
      }"
    >
      <div
        v-if="event.logo_partner"
        class="
          customer-logo
          position-absolute
          d-flex
          justify-content-center
          align-items-center
        "
        v-html="event.logo_partner"
      ></div>
    </a>

    <div class="col-12 col-md-2 mt-4 mt-md-0 align-self-center">
      <div class="date-event">
        <div class="jour" v-html="event.date_object.jour_semaine"></div>
        <div class="numero-jour" v-html="event.date_object.numero_jour"></div>
        <div class="numero-mois" v-html="event.date_object.mois"></div>
      </div>
    </div>

    <div class="col">
      <div class="content-wrapper">
        <p class="full-date" v-html="getFullDate"></p>

        <h2 class="post-title">
          <a :href="event.permalink" v-html="event.post_title"></a>
        </h2>

        <p v-html="event.post_excerpt" class="post-excerpt"></p>

        <div class="row mt-4 align-items-end">
          <div class="col-lg-7" v-html="event.location_event"></div>
          <div class="col-lg-5 text-end mt-4 mt-lg-0">
            <a :href="event.permalink" class="btn btn-arrow btn-sm"
              ><span v-html="$store.state.i18n.discover_more"></span
              ><span class="arrow"><span class="arrow-inner"></span></span
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MiniEvent",
  components: {},
  props: {
    event: Object,
  },
  computed: {
    getFullDate() {
      if (this.event.full_date_event[1] != "") {
        let date = this.event.full_date_event.join(" - ");

        return date;
      } else {
        return this.event.full_date_event[0];
      }
    },
  },
};
</script>
